export default "__VITE_ASSET__p7uRf0vo__"